import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=c413b6e0&scoped=true&"
import script from "./ButtonBase.vue?vue&type=script&lang=js&"
export * from "./ButtonBase.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=c413b6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c413b6e0",
  null
  
)

export default component.exports